import React, { useEffect, useState } from 'react';
import { TabTitle } from '../../utils/GeneralFunction';
import PageHeader from '../../components/PageHeader/PageHeader';
import { Button, Table, Upload, Card, Space, message, Alert, Tag, Input } from 'antd';
import { DownloadOutlined, UploadOutlined, InboxOutlined, FilterFilled, SearchOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from 'axios';
import { BASEURL } from '../../constant/config';
import { ReadCookie } from '../../utils/readCookie';
import moment from 'moment';
import Swal from 'sweetalert2';

const { Dragger } = Upload;

const DropshipActiveProduct = () => {
    TabTitle("Dropship Active Product");

    const token = ReadCookie("token");
    const [activeProductsList, setActiveProductsList] = useState([]);
    const [isNotExists, setIsNotExists] = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Default Columns table display ke liye
    const [columns, setColumns] = useState([
        {
            title: "#",
            dataIndex: "index",
            key: "index",
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Created Date',
            dataIndex: 'created_date',
            key: 'created_date',
            render: (text) => moment(text).format("MM-DD-YYYY"),

        },
        // {
        //     title: 'SKU Status',
        //     dataIndex: 'sku_status',
        //     key: 'sku_status',
        //     render: (text) => (
        //         <Tag color={text === "Correct SKU" ? "success" : "error"}>
        //             {text}
        //         </Tag>
        //     )
        // },
        {
            title: 'Parent SKU',
            dataIndex: 'parent_item_code',
            key: 'parent_item_code',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-170"
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.parent_item_code.toString().toLowerCase().includes(value.toLowerCase()),
            // sorter: (a, b) => {
            //     return a.parent_item_code - b.parent_item_code;
            // },

        },
        {
            title: 'Inseam',
            dataIndex: 'inseam',
            key: 'inseam'
        },
        {
            title: 'Style',
            dataIndex: 'style_name',
            key: 'style_name',

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-170"
                            placeholder="Type text here"
                            value={selectedKeys[0] || ''}
                            onChange={(e) => {
                                setSelectedKeys(
                                    e.target.value ? [e.target.value] : []
                                );

                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm({ closeDropdown: false });
                            }}
                            onBlur={() => {
                                confirm({ closeDropdown: false });
                            }}
                        />
                    </>
                );
            },

            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,

            onFilter: (value, record) => {
                const style = String(record.style_name || '').trim().toLowerCase();
                const search = String(value || '').trim().toLowerCase();

                return style.includes(search);
            },
        },
        {
            title: 'Wash',
            dataIndex: 'wash_name',
            key: 'wash_name',

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
            }) => {
                return (
                    <Input
                        allowClear
                        autoFocus
                        className="pop-search-gen pop-170"
                        placeholder="Type text here"
                        value={selectedKeys[0] || ''}
                        onChange={(e) => {
                            setSelectedKeys(
                                e.target.value ? [e.target.value] : []
                            );
                            confirm({ closeDropdown: false });
                        }}
                        onPressEnter={() => {
                            confirm({ closeDropdown: false });
                        }}
                        onBlur={() => {
                            confirm({ closeDropdown: false });
                        }}
                    />
                );
            },

            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,

            // Exact match (===) ke bajaye includes() use karein
            onFilter: (value, record) => {
                const wash = String(record.wash_name || '').trim().toLowerCase();
                const search = String(value || '').trim().toLowerCase();

                return wash.includes(search);
            },
        },
        
        {
            title: 'Gender',
            dataIndex: 'gender_name',
            key: 'gender_name',

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-170"
                            placeholder="Type text here"
                            value={selectedKeys[0] || ''}
                            onChange={(e) => {
                                setSelectedKeys(
                                    e.target.value ? [e.target.value] : []
                                );

                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm({ closeDropdown: false });
                            }}
                            onBlur={() => {
                                confirm({ closeDropdown: false });
                            }}
                        />
                    </>
                );
            },

            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,

            onFilter: (value, record) => {
                const gender = String(record.gender_name || '').trim().toLowerCase();
                const search = String(value || '').trim().toLowerCase();

                return gender === search;
            },
        },
        // {
        //     title: 'Moda',
        //     dataIndex: 'moda',
        //     key: 'moda',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
        // {
        //     title: 'Maisonette',
        //     dataIndex: 'maisonette',
        //     key: 'maisonette',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
        // {
        //     title: 'Nord Market',
        //     dataIndex: 'nord_market',
        //     key: 'nord_market',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
        // {
        //     title: 'Anthropologie',
        //     dataIndex: 'anthropologie',
        //     key: 'anthropologie',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
        {
            title: 'Nordstrom D2C',
            dataIndex: 'nordstrom_d2c',
            key: 'nordstrom_d2c',
            render: (text) => text ? "TRUE" : "FALSE",
        },
        // {
        //     title: 'Bloomingdales D2C',
        //     dataIndex: 'bloomingdales_d2c',
        //     key: 'bloomingdales_d2c',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
        // {
        //     title: 'Aafes',
        //     dataIndex: 'aafes',
        //     key: 'aafes',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
        // {
        //     title: 'Saks Dropship',
        //     dataIndex: 'saks_d2c',
        //     key: 'saks_d2c',
        //     render: (text) => text ? "TRUE" : "FALSE",
        // },
    ]);

    // Template Download Function with clean headers
    const downloadExcelTemplate = () => {
        const worksheetData = activeProductsList?.length > 0
            ? activeProductsList.map((item) => ({
                "Parent SKU": item.parent_item_code ?? "",
              
                "Inseam": item.inseam ?? "",
                 "Style": item.style_name ?? "",
                "Wash": item.wash_name ?? "",
                "Gender": item.gender_name ?? "",
                // "Moda": item.moda ? true : false,
                // "Maisonette": item.maisonette ? true : false,
                // "Nord Market": item.nord_market ? true : false,
                // "Anthropologie": item.anthropologie ? true : false,
                "Nordstrom D2C": item.nordstrom_d2c ? true : false,
                // "Bloomingdales D2C": item.bloomingdales_d2c ? true : false,
                // "Aafes": item.aafes ? true : false,
                // "Saks Dropship": item.saks_d2c ? true : false,
            }))
            : [
                {
                    "Parent SKU": "",
                    
                    "Inseam": "",
                    "Style": "",
                    "Wash": "",
                    "Gender": "",
                    // "Moda": "",
                    // "Maisonette": "",
                    // "Nord Market": "",
                    // "Anthropologie": "",
                    "Nordstrom D2C": "",
                    // "Bloomingdales D2C": "",
                    // "Aafes": "",
                    // "Saks Dropship": "",
                }
            ];

        // 2. Excel Sheet Generate 
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Active Products");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Dropship-Active-Products.xlsx");
        message.success("Excel downloaded successfully!");
    };

    // Excel Keys ko Snake Case keys me transform karne ka helper function
    const mapExcelRowToSnakeCase = (row) => {
        return {
            parent_item_code: row["Parent SKU"] ?? "",
            inseam: row["Inseam"] ?? "",
            // gender_name: row["Gender Name"] ?? "",
            // moda: row["Moda"] ?? "",
            // maisonette: row["Maisonette"] ?? "",
            // nord_market: row["Nord Market"] ?? "",
            // anthropologie: row["Anthropologie"] ?? "",
            nordstrom_d2c: row["Nordstrom D2C"] ?? "",
            // bloomingdales_d2c: row["Bloomingdales D2C"] ?? "",
            // aafes: row["Aafes"] ?? "",
            // saks_d2c: row["Saks Dropship"] ?? "",
        };
    };

    // File Upload Handler
    const handleFileUpload = (file) => {
        setLoading(true);
        setIsNotExists([]);
        setValidationErrors([]);
        const reader = new FileReader();

        // 1. In line async callback function banayein
        reader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
                console.log("rawData", rawData)
                if (rawData.length > 0) {
                    // Raw Excel keys ko snake_case me convert karein
                    const parsedData = rawData.map((row) => mapExcelRowToSnakeCase(row));


                    try {
                        const response = await axios({
                            method: "POST",
                            url: `${BASEURL}create/activeDropShipProduct`,
                            headers: {
                                Accept: "application/json",
                                Authorization: "Bearer " + token,
                            },
                            data: parsedData, // Clean payload without 'key'
                        });

                        console.log("response", response)
                        if (response?.status === 200) {
                            message.success(response?.data?.message || "Products created successfully!");
                            if (response?.data?.notExists?.length > 0) {
                                setIsNotExists(response?.data?.notExists);
                            }
                            if (response?.data?.validationErrors?.length > 0) {
                                setValidationErrors(response?.data?.validationErrors);
                            }
                            fetchActiveProducts(token);
                        }

                        console.log("response ==>>", response);

                        // if (response?.data?.status || response?.status === 200) {
                        //     message.success(response?.data?.message || "Products created successfully!");

                        //     // Backend se updated data ya frontend parsing data ko table state me set karein
                        //     const tableRows = parsedData.map((item, index) => ({
                        //         key: index,
                        //         ...item,
                        //     }));
                        //     setTableData(tableRows);
                        // }
                    } catch (error) {
                        console.error(
                            "Error creating active dropship product:",
                            error?.response?.data || error?.message
                        );



                        message.error(error?.response?.data?.message || "Failed to create products on server.");
                    }
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "File Error",
                        text: "Uploaded file is empty!",
                    });
                }
            } catch (error) {
                console.error("Error reading file:", error);
                message.error("Failed to read the Excel file. Please upload a valid file.");
            } finally {
                setLoading(false);
            }
        };

        reader.readAsArrayBuffer(file);
        return false; // Auto-upload prevent karne ke liye
    };


    const fetchActiveProducts = async (token) => {
        setLoading(true);
        try {
            const response = await axios({
                method: "POST",
                url: `${BASEURL}getAll/activeDropShipProduct`,
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            if (response?.data?.data) {
                setActiveProductsList(response.data.data);
                setLoading(false);
            }
        } catch (error) {
            console.error(
                "Error fetching active products:",
                error?.response?.data || error?.message
            );
            setLoading(false);
        }
    };


    const downloadExistingExcelTemplate = () => {
        const worksheetData = isNotExists.map((item) => ({
            "Sku": item.sku ?? "",
            "Inseam": item.inseam ?? "",
        }))


        // 2. Excel Sheet Generate 
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Existing Products");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Existing-Dropship-Products.xlsx");
        message.success("Excel downloaded successfully!");
    };

    const downloadValidationErrorsExcel = () => {
        const worksheetData = validationErrors.flatMap((item) =>
            (item.fields || []).map((error) => ({
                "Sku": item.sku ?? "",
                "Inseam": item.inseam ?? "",
                "Field": error.field ?? "",
                "Value": error.value ?? "",
                "Message": error.message ?? "",
            }))
        );

        // Excel Sheet Generate
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Validation Errors"
        );

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Validation-Errors.xlsx");

        message.success("Validation errors Excel downloaded successfully!");
    };

    useEffect(() => {
        if (token) {
            fetchActiveProducts(token);
        }
    }, [token]);

    return (
        <div className="styleContainer" style={{ padding: "20px" }}>
            <PageHeader
                title={"Dropship Active Product"}
                minimize={false}
                check={false}
            />

            <Card style={{ marginBottom: "20px", marginTop: "15px" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    <div>
                        <h4 style={{ margin: 0 }}>Import Active Products</h4>
                        <p style={{ margin: 0, color: '#8c8c8c' }}>Upload your Excel file to populate data.</p>
                    </div>

                    <Space>
                        <Button
                            type="default"
                            icon={<DownloadOutlined />}
                            onClick={downloadExcelTemplate}
                        >
                            Download Template
                        </Button>

                        <Upload
                            beforeUpload={handleFileUpload}
                            showUploadList={false}
                            accept=".xlsx, .xls"
                        >
                            <Button type="primary" icon={<UploadOutlined />}>
                                Upload File
                            </Button>
                        </Upload>
                    </Space>
                </div>
            </Card>
            {
                isNotExists?.length > 0 && (
                    <Alert
                        message="Products Not Found"
                        description={
                            <div style={{ marginTop: "8px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10, alignItems: "center" }}>
                                    <p style={{ marginBottom: "8px", color: '#595959' }}>
                                        The following Products are not found in the system:
                                    </p>
                                    <Button
                                        type="default"
                                        icon={<DownloadOutlined />}
                                        onClick={downloadExistingExcelTemplate}
                                    >
                                        Incorrect Products
                                    </Button>
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                    {isNotExists.map((item, index) => (
                                        <Tag key={index} color="error">
                                            Sku = {item.sku} <br /> Inseam = {item.inseam}
                                        </Tag>
                                    ))}
                                </div>
                            </div>
                        }
                        type="warning"
                        showIcon
                    />
                )
            }
            {
                validationErrors?.length > 0 && (
                    <Alert
                        message="Validation Errors"
                        description={
                            <div style={{ marginTop: "8px" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: 10,
                                        alignItems: "center",
                                    }}
                                >
                                    <p style={{ marginBottom: "8px", color: "#595959" }}>
                                        The following products have validation errors:
                                    </p>

                                    <Button
                                        type="default"
                                        icon={<DownloadOutlined />}
                                        onClick={downloadValidationErrorsExcel}
                                    >
                                        Validation Errors
                                    </Button>
                                </div>

                                {/* Scrollable Validation Errors */}
                                <div
                                    style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                        paddingRight: "8px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                        }}
                                    >
                                        {validationErrors.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    border: "1px solid #ffccc7",
                                                    borderRadius: "6px",
                                                    padding: "10px",
                                                    background: "#fff2f0",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "15px",
                                                        marginBottom: "8px",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    <span>Row = {item.row}</span>
                                                    <span>SKU = {item.sku}</span>
                                                    <span>Inseam = {item.inseam}</span>
                                                </div>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "6px",
                                                    }}
                                                >
                                                    {item.fields?.map(
                                                        (error, fieldIndex) => (
                                                            <Tag
                                                                key={fieldIndex}
                                                                color="error"
                                                            >
                                                                <strong>
                                                                    {error.field}
                                                                </strong>
                                                                {" = "}
                                                                "{error.value}" —{" "}
                                                                {error.message}
                                                            </Tag>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        }
                        type="error"
                        showIcon
                    />
                )
            }
            <Table
                style={{ marginTop: 20 }}
                columns={columns}
                dataSource={activeProductsList}
                loading={loading}
                pagination={{ pageSize: 10 }}
                bordered
                scroll={{ x: 'max-content' }}
            />
        </div>
    );
};

export default DropshipActiveProduct;